// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.stage-header_stage-header-wrapper_cReOX {
    position: absolute;
    top: 0;
}

[dir="ltr"] .stage-header_stage-header-wrapper_cReOX {
    right: 0;
}

[dir="rtl"] .stage-header_stage-header-wrapper_cReOX {
    left: 0;
}

.stage-header_stage-header-wrapper-overlay_MKkga {
    position: fixed;
    background-color: var(--fullscreen-accent);
    top: 0;
    left: 0;
    right: 0;
    z-index: 500;
}

.stage-header_stage-header-wrapper-overlay_MKkga.stage-header_embedded_q5Anu {
    background-color: transparent;
}

.stage-header_stage-menu-wrapper_LaMSW {
    display: flex;
    margin: auto;
    justify-content: space-between;
    flex-shrink: 0;
    align-items: center;
    height: 2.75rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.stage-header_stage-size-row_gTI_9 {
    display: flex;
}

.stage-header_stage-size-toggle-group_iTNjR {
    display: flex;
}

.stage-header_stage-size-row_gTI_9 > *, .stage-header_unselect-wrapper_t4EZB {
    /* Use a white background so semi-transparent selection states look correct */
    background-color: var(--ui-white);
    border-radius: calc(0.5rem / 2);
}

[dir="ltr"] .stage-header_stage-size-toggle-group_iTNjR,
[dir="ltr"] .stage-header_settings-button_RUjGr {
    margin-right: .2rem;
}

[dir="rtl"] .stage-header_stage-size-toggle-group_iTNjR,
[dir="rtl"] .stage-header_settings-button_RUjGr {
    margin-left: .2rem;
}

.stage-header_stage-button_g23bo {
    display: block;
    border: 1px solid var(--ui-black-transparent);
    border-radius: calc(0.5rem / 2);
    width: calc(2rem + 2px);
    height: calc(2rem + 2px);
    background: var(--ui-white);
    padding: 0.375rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: pointer;
}

.stage-header_stage-button_g23bo:active {
    background-color: var(--looks-transparent);
}

.stage-header_stage-button-icon_k_WuU {
    width: 100%;
    height: 100%;
    filter: var(--filter-icon-gray);
}

[dir="rtl"] .stage-header_stage-button-icon_k_WuU {
    transform: scaleX(-1);
}

.stage-header_fullscreen-buttons-row_uUYyZ {
    /* relied on by addons */
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/stage-header/stage-header.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6EAA6E;IAC7E,iCAAiC;IACjC,+BAA+B;AACnC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,6CAA6C;IAC7C,+BAA+B;IAC/B,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,iBAAiB;IACjB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,aAAa;AACjB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.stage-header-wrapper {\n    position: absolute;\n    top: 0;\n}\n\n[dir=\"ltr\"] .stage-header-wrapper {\n    right: 0;\n}\n\n[dir=\"rtl\"] .stage-header-wrapper {\n    left: 0;\n}\n\n.stage-header-wrapper-overlay {\n    position: fixed;\n    background-color: var(--fullscreen-accent);\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 500;\n}\n\n.stage-header-wrapper-overlay.embedded {\n    background-color: transparent;\n}\n\n.stage-menu-wrapper {\n    display: flex;\n    margin: auto;\n    justify-content: space-between;\n    flex-shrink: 0;\n    align-items: center;\n    height: 2.75rem;\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n}\n\n.stage-size-row {\n    display: flex;\n}\n\n.stage-size-toggle-group {\n    display: flex;\n}\n\n.stage-size-row > *, .unselect-wrapper {\n    /* Use a white background so semi-transparent selection states look correct */\n    background-color: var(--ui-white);\n    border-radius: calc(0.5rem / 2);\n}\n\n[dir=\"ltr\"] .stage-size-toggle-group,\n[dir=\"ltr\"] .settings-button {\n    margin-right: .2rem;\n}\n\n[dir=\"rtl\"] .stage-size-toggle-group,\n[dir=\"rtl\"] .settings-button {\n    margin-left: .2rem;\n}\n\n.stage-button {\n    display: block;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: calc(0.5rem / 2);\n    width: calc(2rem + 2px);\n    height: calc(2rem + 2px);\n    background: var(--ui-white);\n    padding: 0.375rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n}\n\n.stage-button:active {\n    background-color: var(--looks-transparent);\n}\n\n.stage-button-icon {\n    width: 100%;\n    height: 100%;\n    filter: var(--filter-icon-gray);\n}\n\n[dir=\"rtl\"] .stage-button-icon {\n    transform: scaleX(-1);\n}\n\n.fullscreen-buttons-row {\n    /* relied on by addons */\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `stage-header_stage-header-wrapper_cReOX`;
export { _1 as "stage-header-wrapper" };
export var stageHeaderWrapper = `stage-header_stage-header-wrapper_cReOX`;
var _2 = `stage-header_stage-header-wrapper-overlay_MKkga`;
export { _2 as "stage-header-wrapper-overlay" };
export var stageHeaderWrapperOverlay = `stage-header_stage-header-wrapper-overlay_MKkga`;
export var embedded = `stage-header_embedded_q5Anu`;
var _3 = `stage-header_stage-menu-wrapper_LaMSW`;
export { _3 as "stage-menu-wrapper" };
export var stageMenuWrapper = `stage-header_stage-menu-wrapper_LaMSW`;
var _4 = `stage-header_stage-size-row_gTI_9`;
export { _4 as "stage-size-row" };
export var stageSizeRow = `stage-header_stage-size-row_gTI_9`;
var _5 = `stage-header_stage-size-toggle-group_iTNjR`;
export { _5 as "stage-size-toggle-group" };
export var stageSizeToggleGroup = `stage-header_stage-size-toggle-group_iTNjR`;
var _6 = `stage-header_unselect-wrapper_t4EZB`;
export { _6 as "unselect-wrapper" };
export var unselectWrapper = `stage-header_unselect-wrapper_t4EZB`;
var _7 = `stage-header_settings-button_RUjGr`;
export { _7 as "settings-button" };
export var settingsButton = `stage-header_settings-button_RUjGr`;
var _8 = `stage-header_stage-button_g23bo`;
export { _8 as "stage-button" };
export var stageButton = `stage-header_stage-button_g23bo`;
var _9 = `stage-header_stage-button-icon_k_WuU`;
export { _9 as "stage-button-icon" };
export var stageButtonIcon = `stage-header_stage-button-icon_k_WuU`;
var _a = `stage-header_fullscreen-buttons-row_uUYyZ`;
export { _a as "fullscreen-buttons-row" };
export var fullscreenButtonsRow = `stage-header_fullscreen-buttons-row_uUYyZ`;
export default ___CSS_LOADER_EXPORT___;
